export function stringToNumberList(str: string | undefined): number[] | undefined {
  return str?.length !== 0 ? str?.split(',').map((s) => Number(s)) : undefined;
}

export function getPaymentAccountLabel(account: {
  fakturaCustomerRefNo: number;
  accountNumber: number;
  accountName: string;
}) {
  return `${account.fakturaCustomerRefNo}[${account.accountNumber}] ${account.accountName}`;
}
